import React from 'react';

export const CanopyLogo = () => (
  <a href="/#">
    <img alt="Canopy Logo" src="https://cdn.canopytax.com/static/primary-navbar/canopy-logo-light.svg" />
  </a>
);
